let domen = 'api.kcsni-service.ru';

let https = 'https';
if (process.env.NODE_ENV === 'development') {
  domen = '127.0.0.1:8001';
  https = 'http';
}
export const CURRENT_MEETING_ID = 4;
export const DOMEN = `${https}://${domen}`;
export const AUTH_URL = `${https}://${domen}/accounts/`;
export const USER_INDIVIDUAL_DETAIL_URL = `${https}://${domen}/api/users/individual/detail_rsini/`;
export const REFERENCES_URL = `${https}://${domen}/api/references/`;
export const FILE_POST_URL = `${https}://${domen}/api/references/file/detail/`;

export const GET_CHART_DATA_URL = `${https}://${domen}/api/users/chart/data/`;

export const GET_ATTENDANCE_LIST_URL = `${https}://${domen}/api/users/attendance/list/`;
export const GET_LIST_USER_MEETING_URL = `${https}://${domen}/api/users/user_meeting/list/`;
export const GET_LIST_POSTER_URL = `${https}://${domen}/api/users/user_meeting/poster_list/`;
export const GET_USER_MEETING_REG_URL = `${https}://${domen}/api/users/user_meeting_reg/list/`;
export const MAKE_REGISTRATION_URL = `${https}://${domen}/api/users/registration/make/`;
export const ADD_THESIS_FILE_URL = `${https}://${domen}/api/users/registration/add_file/`;
export const EXPORT_USER_LIST_TO_EXCEL_URL = `${https}://${domen}/api/users/export/excel/`;
export const CHANGE_REGISTRATION_URL = `${https}://${domen}/api/users/registration/change/`;
export const MAKE_INVITE_URL = `${https}://${domen}/api/users/registration/invite/`;
export const MAKE_SERT_URL = `${https}://${domen}/api/users/registration/sert/`;
export const GET_SECTIONS_URL = `${https}://${domen}/api/users/user_meeting/sections/`;
export const USERMEETING_DETAIL_URL = `${https}://${domen}/api/users/user_meeting/get/`;
export const CHANGE_USERMEETING_URL = `${https}://${domen}/api/users/user_meeting/change/`;
export const LOAD_EMAIL_LIST_URL = `${https}://${domen}/api/users/profile/emails_list/`;
